// this is an autogenerated file from App/Account/Content/Settings/Content/Charges/ActionsAction/Content/Content/DeleteAction/Confirmation/Content/mutation.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__App_Account_Content_Settings_Content_Charges_ActionsAction_Content_Content_DeleteAction_Confirmation_Content($ids: [numeric!]!) {
  delete_vaxiom_misc_fee_charge_templates(where: { id: { _in: $ids } }) {
    affected_rows
  }
}

`